<template>
  <div class="theme3">
    <header-page ref="headerPage"></header-page>
    <div class="content-box">
      <div class="index-row" v-if="routers && routers.length > 0 && $route.path !='/base-setting'" >
        <div class="col left-column" id="main-left-cloumn" >
          <div class="tab" id="cate0" @click="selectMenu('all')"><i class="wk wk-bolder wk-navicon"></i> {{ routers[0].parentMenuName }}</div>
          <div class="sidebar-box gallery-list normal-menu-list">
            <div class="normal-menu-item"   v-for="item in routers" :id="item.index" @click="handleSelect(item.path)" :class="$route.name === item.name ? 'is-select-menu' : ''">
                <i class="wk wk-tag1" v-if="$route.name === item.name"></i>
                <span>{{ item.meta != null ? item.meta.title : ''}}</span>
            </div>
          </div>
        </div>

        <div class="col middleright-column">
          <div class="index-rollback">
            <div style="display: inline-block; cursor: pointer;" @click="rollback()">
              <i class="wk wk-rollback" style="font-weight: bolder; margin-right: 5px;"></i><span>{{$route.meta.title}}</span>
            </div>


<!--            <div style="float: right; margin-right: 5px; cursor: pointer;" v-if="">-->
<!--              生成采购单-->
<!--            </div>-->
          </div>
          <router-view v-slot="{ Component }" :key="$route.name">
            <slot name="header">11111</slot>
            <transition name="move" mode="out-in">
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>

      <div class="content" v-else>
        <router-view v-slot="{ Component }" :key="$route.name">

          <transition name="move" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>

<!--    <div style=" text-align: center;width: 100%;color: #999; font-size: 12px;padding: 20px 0;">-->
<!--      华夏百科控股集团有限公司&nbsp;&nbsp;&nbsp;技术支持电话：13688888888-->
<!--    </div>-->

    <div class="index-foot-div">
      <div class="footer-content">
        <span class="footer-item">华夏百科控股集团有限公司</span>
        <span class="footer-separator"></span>
        <span class="footer-item">技术支持电话:135-2208-6032</span>
        <span class="footer-separator"></span>
        <span class="footer-item">备案号:京ICP备2025154646号-1</span>
      </div>
    </div>
  <vip-remind ref="vipRemind" v-if="isVipRemindShow"></vip-remind>

  </div>
</template>

<script>
import headerPage from './HeaderPage'
import vTags from "../../Tags.vue";
import {mapGetters} from "vuex";
import VipRemind from '../../../views/base/remind/item/vip-remind'

export default {
  name: "index",
  data() {
    return {
      routers: [],
      defaultOpenArr: [],
      activeMenu: '',
      isVipRemindShow: false,
      defaultHeight: {
        height: ""
      },
    };
  },
  components: {
    headerPage,
    vTags,
    VipRemind
  },
  watch: {
    '$route': 'defaultLeftNavOpened'  //监听router值改变时，改变导航菜单激活项
  },
  computed: {
    tagsList() {
      return this.$store.state.tagsList.map(item => item.name);
    },
    expiredStatus() {
      return this.$store.getters.expiredStatus; //获取机构类型
    },
    roleCode() {
      return this.$store.getters.roleCode; //获取角色编码
    },
    // isVipRemindShow() {
    //   if(this.expiredStatus() == 1 || this.expiredStatus() == 2) {
    //     return true;
    //   }
    //   return false; //
    // },
    ...mapGetters([
      'routesLists'
    ]),
  },
  methods: {
    //返回上一步
    rollback(){
      this.$router.go(-1);
    },
    //选择菜单
    handleSelect(path) {
      this.$router.push(path)
    },

    //定义方法，获取高度减去头尾
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 80 + "px";
    },

    // 左侧导航栏根据当前路径默认打开子菜单（如果当前路由是三级，则父级子菜单默认打开）
    defaultLeftNavOpened () {
      let defaultOpenArr = [];
      let cur_path = this.$route.path; //获取当前路由
      let routers = []; // 获取路由对象
      let routesLists = this.routesLists;
      let topName = "";
      if(this.$route && this.$route.meta && this.$route.meta.topName){
          topName = this.$route.meta.topName;
      }
      for(let i = 0; i < routesLists.length; i++){
        if(routesLists[i].name == topName && routesLists[i].children && routesLists[i].children.length > 0){
          routers = routesLists[i].children
        }
      }




      let subMenuIndex = 0, needOpenSubmenu = false;
      for (let i = 0; i < routers.length; i++) {
        let children = routers[i].children;
        if(children){
          let isNowChild = false;
          for(let j = 0; j < routers.length; j++){
            if(children[j] && children[j].name == this.$route.name){
              isNowChild = true;
            }
          }
          //如果这个菜单是当前路由的地址
          if(!!routers[i].index && isNowChild){
            defaultOpenArr.push(routers[i].index)
          }

          for (let j = 0; j < children.length; j++) {
            if (children[j].path === cur_path) {
              break;
            }
            // 如果该菜单下有子菜单(个数>1且设置的leaf为false才有下拉子菜单)
            if(children[j].children && !children[j].leaf) {
              let grandChildren = children[j].children;
              for(let z=0; z<grandChildren.length; z++) {
                if(grandChildren[z].path === cur_path) {
                  subMenuIndex = j;
                  needOpenSubmenu = true;
                  break;
                }
              }
            }
          }
        }
      }
      if(this.$refs['leftNavigation'] && needOpenSubmenu) {
        this.$refs['leftNavigation'].open(subMenuIndex); // 打开子菜单
      }

      this.routers = routers;
      this.defaultOpenArr = defaultOpenArr;

    },
  },
  created() {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    // window.addEventListener("resize", this.getHeight);
    this.getHeight();
    let expiredStatus = this.$store.getters.expiredStatus; //获取机构类型
    if(expiredStatus == 1 || expiredStatus == 2){
      this.isVipRemindShow = true;
    }else{
      this.isVipRemindShow = false;
    }




  },
  mounted() {
    this.defaultLeftNavOpened();
  },
}
</script>

<style scoped>

  .el-menu-item.is-select-menu{background: #e6f7ff !important; color: #1890FF !important;}
  /deep/.leftSidebar-main .el-submenu__title:hover{background: #FFF !important; color: #1890FF !important;}
  .el-menu-item:hover{background: #e6f7ff !important; color: #1890FF !important;}
  .el-menu-item.is-select-menu:after{position: absolute; top: 0; right: 0; bottom: 0; border-right: 3px solid #1890FF;content: ''}
  .el-menu-item{height: 50px !important;line-height: 50px !important; font-size: 14px;}
  /deep/.leftSidebar-main .el-menu-item{height: 50px !important; line-height: 50px !important;}
  /deep/.leftSidebar-main .el-submenu__title{height: 50px !important; line-height: 50px !important;}

  .layout-left{overflow-x: hidden; overflow-y: auto;}
  .el-submenu .wk{
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    display: inline-block;
  }

  .el-menu-item .wk{
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    display: inline-block;
  }

  .index-rollback{
    line-height: 24px;
    overflow: hidden;
    padding: 10px 10px 10px 10px;
    background: #fbfbfb;
    border-top: 1px solid #efefef;
    border-bottom: 1px solid #efefef;
    color: #8590a6;
    font-size: 15px;
    box-shadow: 0 1px 3px rgba(0, 37, 55, .05);
    box-sizing: border-box;
  }

  .index-foot-div{
    width: 100%;
    min-height: 60px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: top center;
    background-image: url('../../../assets/img/head-bc.png');
    /* 删除 fixed 定位，改用相对定位 */
    position: relative;
    /* 删除 bottom: 0 */
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px; /* 添加顶部间距 */
  }

  .footer-content {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 14px;
    text-align: center;
    width: 100%;
  }

  .footer-item {
    margin: 0 15px;
    white-space: nowrap;
  }

  .footer-separator {
    margin: 0 15px;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/theme/theme3/index.vue